module.exports = __webpack_public_path__ + "static/media/French doors   (4).f9bea1c7.jpg";